<template>
<router-view></router-view>
</template>

<script>
import bgImage from '@/assets/images/bg.jpg';
import Api from '@/helpers/api';

export default {
  data() {
    return {
      api: new Api(),
      bgImage,
      latitude: null,
      longitude: null,
      errorMessage: null,
      permissionDenied: false,
      isLoading: true,
      currentStatusText: "Calcul de l'itinéraire du livreur...",
      isDelivered: false,
      watchId: null,
      trackingToken: "VOTRE_TOKEN_ICI"
    };
  },
  mounted() {

  },
  beforeUnmount() {

  },
  methods: {

  },
};
</script>

<style scoped>
.tracking-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.tracking-card {
  background: rgba(255, 255, 255, 0.95);
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  padding: 30px;
  box-sizing: border-box;
}
.header-brand {
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.badge-express {
  background-color: #e0e7ff;
  color: #3730a3;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.header-brand h2 {
  font-size: 1.4rem;
  color: #1f2937;
  margin: 10px 0 5px 0;
}
.tracking-number {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0;
}
.status-box {
  text-align: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 25px;
}
.status-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}
.status-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 8px 0;
}
.status-desc {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0;
}
.alert-custom {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  padding: 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-bottom: 20px;
  text-align: center;
}
.timeline {
  margin: 20px 0;
  padding-left: 10px;
  border-left: 2px solid #e5e7eb;
}
.timeline-step {
  position: relative;
  margin-bottom: 20px;
  padding-left: 20px;
}
.timeline-step:last-child {
  margin-bottom: 0;
}
.timeline-step .bullet {
  position: absolute;
  left: -6px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #cbd5e1;
}
.timeline-step.completed .bullet {
  background-color: #10b981;
}
.timeline-step.active .bullet {
  background-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
}
.timeline-step .time {
  font-size: 0.75rem;
  font-weight: 600;
  color: #9ca3af;
  display: block;
}
.timeline-step p {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 2px 0 0 0;
}
.footer-info {
  text-align: center;
  margin-top: 25px;
  border-top: 1px solid #f3f4f6;
  padding-top: 15px;
  color: #9ca3af;
}
</style>